import { Component } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { user } from 'firebase-functions/lib/providers/auth';
import { fadeInAnimation } from './_animations/fade-in.animation';
import { slideInAnimation } from './_animations/slide-in.animation';

@Component({
  selector: 'mdwg-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // animations: [fadeInAnimation]
  animations: [slideInAnimation, fadeInAnimation]
})

export class AppComponent {

  title: string;
  rootPage: string;

  constructor(afAuth: AngularFireAuth) {
    this.title = 'mobidawg-llc epic';

    console.debug("*** Initializing Firebase: auth-state is => " + afAuth.authState);

    afAuth.authState.subscribe( user => {
      if (user) {
         this.rootPage = 'HomePage';
      } else {
        this.rootPage = 'SignupPage';
      }

    });
  }
}
